module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00009-449e05752093c75e6d95bc121ebf3f3a.jpg";